<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">

            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Assessment Responden</h5>
              <!-- <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
										v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form> -->
            </div>

            <div class="card p-3 shadow-sm">
              <form @submit.prevent="getDataList" id="filterForm" class="row g-3 align-items-end">
                <div class="col-md-3 offset-4">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control"
                    id="filterNama"
                    placeholder="Pencarian nama"
                  >
                </div>

                <div class="col-md-3">
                  <input
                    v-model="cariNik"
                    type="text"
                    class="form-control"
                    id="filterNik"
                    placeholder="Pencarian NIK"
                  >
                </div>
                <div class="col-2 d-flex justify-content-end gap-2 mt-0">
                  <button type="button" class="btn btn-secondary" @click="resetFilter" id="btnReset">Reset</button>
                  <button type="submit" class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>

            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav nav-pills mb-4 gap-1" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-0-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-0"
                  type="button"
                  role="tab"
                  aria-controls="pills-0"
                  aria-selected="true"
                >Aktivitas (Intrapartum)</button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-1-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-1"
                  type="button"
                  role="tab"
                  aria-controls="pills-1"
                  aria-selected="false"
                >Evaluasi (Postpartum)</button>
              </li>
            </ul>

            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-0"
                role="tabpanel"
                aria-labelledby="pills-0-tab"
                tabindex="0"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-50 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-50 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-25 text-center text-nowrap" scope="col">Nama Kehamilan</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap w-100" scope="col">
                          <a href="#" class="link-dark">
                            HPL
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal Assessment
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(req, idx) in activity" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td class="text-nowrap">{{req.fullname}}</td>
                        <td class="text-nowrap">{{req.nik}}</td>
                        <td class="text-center text-nowrap">{{req.profile_kehamilan}}</td>
                        <td class="text-center">{{req.usia_kehamilan}} Minggu</td>
                        <td class="text-center">{{formatDate(req.hpl) || '-'}}</td>
                        <td class="text-center text-nowrap">{{formatDate(req.assessment_date)}}</td>
                        <td class="text-nowrap text-end">
                          <button
                            @click="detail(req.assessment_date, req.userId)"
                            class="btn btn-sm btn-outline-warning me-1"
                            title="Kirim Pesan"
                            data-bs-toggle="modal"
                            data-bs-target="#modalNewMessage"
                          >
                            <i class="ti ti-message fs-3"></i>
                          </button>
                          <button
                            class="btn btn-sm btn-outline-success"
                            title="Detail"
                            @click="detail(req.assessment_date, req.userId)"
                            data-bs-toggle="modal"
                            data-bs-target="#modalDetailAssessmentActivity"
                          >
                            <i class="ti ti-file-check fs-3"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-1"
                role="tabpanel"
                aria-labelledby="pills-1-tab"
                tabindex="0"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-50 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-50 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-25 text-center text-nowrap" scope="col">Nama Kehamilan</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal Kelahiran
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Jenis Persalinan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal Evaluasi
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(req, idx) in evaluation" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td class="text-nowrap">{{req.fullname}}</td>
                        <td class="text-nowrap">{{req.nik}}</td>
                        <td class="text-center text-nowrap">{{req.profile_kehamilan}}</td>
                        <td class="text-center">{{req.tanggal_lahir || '-'}}</td>
                        <td class="text-center">
                          <small
                            :class="req.jenis_persalinan == 'Normal' ? 'text-bg-primary' : 'text-bg-secondary'"
                            class="badge fs-1 bg-opacity-75"
                          >{{ req.jenis_persalinan || '-' }}</small>
                        </td>
                        <td class="text-center">{{formatDate(req.assessment_date)}}</td>
                        <td class="text-nowrap text-end">
                          <button
                            @click="openModalMessage()"
                            class="btn btn-sm btn-outline-warning me-1"
                            title="Kirim Pesan"
                            data-bs-toggle="modal"
                            data-bs-target="#modalNewMessage"
                          >
                            <i class="ti ti-message fs-3"></i>
                          </button>
                          <button
                            class="btn btn-sm btn-outline-success"
                            title="Detail"
                            @click="detail(req.assessment_date, req.userId)"
                            data-bs-toggle="modal"
                            data-bs-target="#modalDetailAssessmentEvaluation"
                          >
                            <i class="ti ti-file-check fs-3"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="dataList.length"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detail Assessment -->
    <div
      class="modal fade"
      id="modalDetailAssessmentEvaluation"
      tabindex="-1"
      aria-labelledby="modalDetailAssessmentEvaluationLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1
              class="modal-title fs-5"
              id="modalDetailAssessmentEvaluationLabel"
            >Detail Assessment - Postpartum</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-2 justify-content-between align-items-center">
              <div class="col-xl-4">
                <label for class="small mb-1">Profil : {{form.profile_kehamilan}}</label>
                <div class="form-label">{{form.fullname}}</div>
              </div>
              <div class="col-xl-3">
                <label for class="small mb-1">Tanggal Kelahiran :</label>
                <div class="form-label">{{form.tanggal_lahir || '-'}}</div>
              </div>
              <div class="col-xl-2">
                <label for class="small mb-1">Jenis Persalinan :</label>
                <div class="form-label">
                  <span class="badge text-bg-primary">{{form.jenis_persalinan || '-'}}</span>
                </div>
              </div>
              <div class="col-xl-3">
                <label for class="small mb-1">Tanggal Assessment :</label>
                <div class="form-label">{{formatDate(form.assessment_date)}}</div>
              </div>
            </div>

            <hr>

            <!-- Tab Header -->
            <ul class="nav nav-pills mb-4 gap-1" id="myTab" role="tablist">
              <li class="nav-item" v-for="(people, city, index) in groupedAssessment" :key="city">
                <button
                  class="nav-link"
                  :class="{ active: index === 0 }"
                  data-bs-toggle="tab"
                  :data-bs-target="'#tab-' + slugify(city)"
                  type="button"
                  role="tab"
                >{{ city }} ({{ people.length }})</button>
              </li>
            </ul>
            <!-- Tab Content -->
            <div class="tab-content mt-3" id="myTabContent">
              <div
                v-for="(people, city, index) in groupedAssessment"
                :key="city"
                class="tab-pane fade"
                :class="{ 'show active': index === 0 }"
                :id="'tab-' + slugify(city)"
                role="tabpanel"
              >
                <label for class="col-form-label fs-4">{{ city }}</label>
                <div class="table-responsive">
                  <table class="table table-sm align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-100 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Evaluasi
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center" scope="col">Jawaban</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(person, i) in people" :key="`ques-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{ person.question }}</td>
                        <td class="text-center">{{ person.answer }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Tutup</button>
            <button
              type="button"
              class="btn btn-warning"
              data-bs-target="#modalNewMessage"
              data-bs-toggle="modal"
              @click="openModalMessage()"
            >Kirim Pesan</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detail Assessment -->
    <div
      class="modal fade"
      id="modalDetailAssessmentActivity"
      tabindex="-1"
      aria-labelledby="modalDetailAssessmentActivitylLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1
              class="modal-title fs-5"
              id="modalDetailAssessmentActivitylLabel"
            >Detail Assessment - Aktivitas</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-2 justify-content-between align-items-center">
              <div class="col-xl-4">
                <label for class="small mb-1">Profil : {{form.profile_kehamilan}}</label>
                <div class="form-label">{{form.fullname}}</div>
              </div>
              <div class="col-xl-3">
                <label for class="small mb-1">Usia Kehamilan :</label>
                <div class="form-label">{{form.usia_kehamilan}} Minggu</div>
              </div>
              <div class="col-xl-2">
                <label for class="small mb-1">HPL :</label>
                <div class="form-label">{{formatDate(form.hpl) || '-'}}</div>
              </div>
              <div class="col-xl-3">
                <label for class="small mb-1">Tanggal Assessment :</label>
                <div class="form-label">{{formatDate(form.assessment_date)}}</div>
              </div>
            </div>

            <hr>

            <!-- Tab Header -->
            <ul class="nav nav-pills mb-4 gap-1" id="myTab" role="tablist">
              <li class="nav-item" v-for="(people, city, index) in groupedAssessment" :key="city">
                <button
                  class="nav-link"
                  :class="{ active: index === 0 }"
                  data-bs-toggle="tab"
                  :data-bs-target="'#tab-' + slugify(city)"
                  type="button"
                  role="tab"
                >{{ city }} ({{ people.length }})</button>
              </li>
            </ul>
            <!-- Tab Content -->
            <div class="tab-content mt-3" id="myTabContent">
              <div
                v-for="(people, city, index) in groupedAssessment"
                :key="city"
                class="tab-pane fade"
                :class="{ 'show active': index === 0 }"
                :id="'tab-' + slugify(city)"
                role="tabpanel"
              >
                <label for class="col-form-label fs-4">{{ city }}</label>
                <div class="table-responsive">
                  <table class="table table-sm align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Aktivitas
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center" scope="col">Jawaban</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Potensi Resiko
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-nowrap" scope="col">Jenis Resiko</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(person, i) in people" :key="`ques-ass-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{ person.question }}</td>
                        <td class="text-center">{{ person.answer }}</td>
                        <td class="text-center">
                          <small
                            class="badge fs-1 bg-opacity-75 text-bg-<?php print ($i%2 !== 0 ) ? 'success' : 'danger'; ?>"
                            :class="person.is_at_risk == 1 ? 'text-bg-danger' : 'text-bg-success'"
                          >{{ person.is_at_risk }}</small>
                        </td>
                        <td class="fst-italic small">{{ person.risk_name || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Tutup</button>
            <button
              type="button"
              class="btn btn-warning"
              data-bs-target="#modalNewMessage"
              data-bs-toggle="modal"
              @click="openModalMessage()"
            >Kirim Pesan</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal New Message -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="modalNewMessage"
        tabindex="-1"
        aria-labelledby="modalNewMessageLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewMessagelLabel">Kirim Pesan</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form>
                <div class="mb-4">
                  <label for class="form-label">Penerima / Responden</label>
                  <input
                    v-model="penerima"
                    type="text"
                    class="form-control"
                    value="Sahira Marwa Suryaningsih - 3578024512900001"
                    placeholder="Penerima / Responden..."
                    rows="3"
                    autocomplete="off"
                    disabled
                  >
                </div>
                <div class="mb-4">
                  <label for class="form-label">Subjek *</label>
                  <input
                    v-model="formPesan.subject"
                    class="form-control"
                    placeholder="Subjek..."
                    value="Pesan Baru"
                    autocomplete="off"
                    required
                  >
                </div>
                <div>
                  <label for class="form-label">Pesan *</label>
                  <textarea
                    v-model="formPesan.messages"
                    class="form-control"
                    placeholder="Isi Pesan..."
                    rows="3"
                    required
                  ></textarea>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success liveToastBtn">Kirim Pesan</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				assessment_date: '',
				fullname: '',
				hpht: '',
				hpl: '',
				profile_kehamilan: '',
				type: '',
				usia_kehamilan: '',
				tanggal_lahir: '',
				jenis_persalinan: ''
			},
			formPesan: {
				klasifikasi: 'Personal',
				responden: '',
				subject: '',
				messages: ''
			},
			cariTitle: '',
			cariNik: '',
			penerima: '',
			activeTab: 'activity' // default tab
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDataPayload',
			dataDetailList: 'location/getDataPayload2',
			countDataList: 'location/getCountDCLocation'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		activity() {
			return this.dataList.length > 0 ? this.dataList.filter((a) => a.type == 'activity') : []
		},
		evaluation() {
			return this.dataList.length > 0 ? this.dataList.filter((a) => a.type == 'evaluation') : []
		},
		assessment() {
			return this.dataList.length > 0 ? this.dataList.filter((a) => a.type == 'assessment') : []
		},
		groupedAssessment() {
			return this.dataDetailList.reduce((acc, assessment) => {
				// ambil key berdasarkan atribut
				let key = assessment.section
				// kalau belum ada, buat array kosong
				if (!acc[key]) acc[key] = []
				// push data ke group yang sesuai
				acc[key].push(assessment)
				return acc
			}, {})
		}
	},
	methods: {
    resetFilter(){
      this.cariTitle = ''
      this.cariNik = ''
    },
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_assessment`,
					params: {
						fullname: this.cariTitle,
						nik: this.cariNik,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		detail(assessment_date, userId) {
			let data = this.dataList.find((o) => o.assessment_date === assessment_date)
			this.form = {
				assessment_date: assessment_date,
				fullname: data.fullname,
				hpht: data.hpht,
				hpl: data.hpl,
				profile_kehamilan: data.profile_kehamilan,
				type: data.type,
				usia_kehamilan: data.usia_kehamilan,
				tanggal_lahir: data.tanggal_lahir,
				jenis_persalinan: data.jenis_persalinan
			}

			this.$store.dispatch('location/getDataPayload2', {
				url: `user_assessment/` + userId,
				params: {
					assessment_date: assessment_date
				}
			})
			this.penerima = data.fullname
			this.formPesan.responden = userId
		},
		slugify(text) {
			return text.toLowerCase().replace(/\s+/g, '-')
		},
		openModalMessage() {
			let data = this.dataList.find((o) => o.assessment_date === assessment_date)
			this.penerima = data.fullname
			this.formPesan.responden = userId
		},
		onSubmit() {
			const data = new URLSearchParams()
			data.append('klasifikasi', this.formPesan.klasifikasi)
			data.append('responden', this.formPesan.responden)
			data.append('subject', this.formPesan.subject)
			data.append('messages', this.formPesan.messages)

			this.$store
				.dispatch('location/createNewRecord', {
					data: data,
					url: 'messages/' + this.user_login.id,
					method: 'POST'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#modalNewMessage [data-bs-dismiss="modal"]').click()
						this.formPesan = {
							klasifikasi: 'Personal',
							responden: '',
							subject: '',
							messages: ''
						}
					} else {
					}
				})
		},
		formatDate(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			return `${day}/${m}/${y}`
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
